<template>
  <el-form
    class="search_form"
    inline
    size="small"
    label-suffix=":"
    label-position="right"
  >
    <el-form-item label="入库时间">
      <el-date-picker
        class="date_picker"
        size="mini"
        type="datetimerange"
        v-model="searchForm.createTimeRange"
        range-separator="-"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        placeholder="选择时间范围"
        @change="changeSearch"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item label="指数日期">
      <el-date-picker
        class="date_picker"
        size="mini"
        type="datetimerange"
        v-model="searchForm.dateRange"
        range-separator="-"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        placeholder="选择时间范围"
        @change="changeSearch"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item label="关键词">
      <el-input
        class="filter"
        placeholder="请输入关键词"
        v-model="searchForm.keyword"
        clearable
        @change="changeSearch"
      ></el-input>
    </el-form-item>
    <el-form-item label="站点">
      <el-select
        class="query_select"
        clearable
        v-model="searchForm.sourceSite"
        @change="changeSearch"
      >
        <el-option
          v-for="e in siteList"
          :key="e.sourceSite"
          :label="e.sourceSite"
          :value="e.sourceSite"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="品牌">
      <el-select
        class="query_select"
        clearable
        v-model="searchForm.brandName"
        @change="changeSearch"
      >
        <el-option
          v-for="e in brandList"
          :key="e.brandName"
          :label="e.brandName"
          :value="e.brandName"
        ></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        brandName: "",
        sourceSite: "",
        keyword: "",
        dateRange: [],
        createTimeRange: [],
      },
      siteList: [],
      brandList: [],
    };
  },
  watch: {
    // searchForm: {
    //   handler(val) {
    //     const dateRange =
    //       val.dateRange.length > 0
    //         ? [
    //             this.$moment(val.dateRange[0]).valueOf(),
    //             this.$moment(val.dateRange[1]).valueOf(),
    //           ]
    //         : [];
    //     const createTimeRange =
    //       val.createTimeRange.length > 0
    //         ? [
    //             this.$moment(val.createTimeRange[0]).valueOf(),
    //             this.$moment(val.createTimeRange[1]).valueOf(),
    //           ]
    //         : [];
    //     const searchObj = {
    //       brandName: val.brandName,
    //       sourceSite: val.sourceSite,
    //       keyword: val.keyword,
    //       dateRange,
    //       createTimeRange,
    //     };
    //     this.$emit("search-change", searchObj);
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    this.searchForm.createTimeRange = [
      this.$moment().subtract(1, "days").valueOf(),
      new Date().getTime(),
    ];
    console.log(this.searchForm.createTimeRange);
    this.getSiteList();
    this.getBrandList();
  },
  methods: {
    // 获取站点下拉
    getSiteList() {
      this.$http({
        url: "/searchData/getParamsList",
        method: "get",
        params: {
          params: "site",
        },
        cancelTag: "getParamsSite",
      })
        .then((res) => {
          if (res.code === 200) {
            this.siteList = res.data;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "获取站点列表请求失败",
            type: "error",
          });
        });
    },

    // 获取品牌下拉
    getBrandList() {
      this.$http({
        url: "/searchData/getParamsList",
        method: "get",
        params: {
          params: "brand",
        },
        cancelTag: "getParamsBrand",
      })
        .then((res) => {
          if (res.code === 200) {
            this.brandList = res.data;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "获取品牌列表接口请求失败",
            type: "error",
          });
        });
    },
    changeSearch() {
      const dateRange =
        this.searchForm.dateRange && this.searchForm.dateRange.length > 0
          ? [
              this.$moment(this.searchForm.dateRange[0]).valueOf(),
              this.$moment(this.searchForm.dateRange[1]).valueOf(),
            ]
          : [];
      const createTimeRange =
        this.searchForm.createTimeRange &&
        this.searchForm.createTimeRange.length > 0
          ? [
              this.$moment(this.searchForm.createTimeRange[0]).valueOf(),
              this.$moment(this.searchForm.createTimeRange[1]).valueOf(),
            ]
          : [];
      const searchObj = {
        brandName: this.searchForm.brandName,
        sourceSite: this.searchForm.sourceSite,
        keyword: this.searchForm.keyword,
        dateRange,
        createTimeRange,
      };
      this.$emit("search-change", searchObj);
    },
  },
};
</script>

<style lang="scss">
.search_form {
  display: flex;
  justify-content: end;
  .date_picker {
    width: 320px;
  }
  .query_select {
    width: 100px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/views/indexQuery/querySearch.vue